import { render, staticRenderFns } from "./LoadingTable.vue?vue&type=template&id=5d0a5c44&scoped=true&"
var script = {}
import style0 from "./LoadingTable.vue?vue&type=style&index=0&id=5d0a5c44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0a5c44",
  null
  
)

export default component.exports